import React, { useEffect, useState } from "react";
import AppTextInput from "components/AppTextInput";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
} from "@mui/material";
import { downloadFileAPI } from "services/API/fileManager";
import { Modal, ModalContent } from "components/Images/ModalImage";

const UserAddress = ({ data }) => {
  const basicInfo = data;
  const [values, setValues] = useState({});
  const [images, setImages] = useState(null);
  const [isOpen, setIsopen] = useState(false);
  const showModal = () => setIsopen((prev) => !prev);
  useEffect(() => {
    if (basicInfo) {
      setValues({
        addressLine1: basicInfo.addressLine1,
        addressLine2: basicInfo.addressLine2,
        addressProof: basicInfo.addressProof,
        city: basicInfo.city,
        country: basicInfo.country,
        postalCode: basicInfo.postalCode,
        state: basicInfo.state,
      });
    }
  }, [basicInfo]);

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };
  async function showImage() {
    try {
      let response = await downloadFileAPI({
        fileAddress: values.addressProof,
      });
      let base64Data = `data:${response.data.type};base64,${response.data.value}`;
      if (response.status === "success") {
        setImages(base64Data);
      }
    } catch (error) {
      console.log(error.message);
    }
  }
  useEffect(() => {
    if (values.addressProof) {
      showImage();
    }
  }, [values]);

  return (
    <Card>
      <CardHeader title="Address Info" />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={4}>
            <AppTextInput
              label="Address Line 1"
              value={values.addressLine1}
              onChange={handleChange("addressLine1")}
              // disabled={basicInfo.deleted_at != null ? true : false}
              dir="ltr"
            />
          </Grid>
          <Grid item xs={4}>
            <AppTextInput
              label="Address Line 2"
              value={values.addressLine2}
              onChange={handleChange("addressLine2")}
              // disabled={basicInfo.deleted_at != null ? true : false}
              dir="ltr"
            />
          </Grid>
          <Grid item xs={4}>
            <AppTextInput
              label={"Email "}
              value={values.postalCode}
              onChange={handleChange("postalCode")}
              dir="ltr"
              // disabled={basicInfo.deleted_at != null ? true : false}
            />
          </Grid>
          <Grid item xs={4}>
            <AppTextInput
              label="City"
              value={values.city}
              onChange={handleChange("cityid")}
              // disabled={basicInfo.deleted_at != null ? true : false}
              dir="ltr"
            />
          </Grid>
          <Grid item xs={4}>
            <AppTextInput
              label={"State"}
              value={values.state}
              onChange={handleChange("stateId")}
              dir="ltr"
              // disabled={basicInfo.deleted_at != null ? true : false}
            />
          </Grid>
          <Grid item xs={4}>
            <AppTextInput
              label="Country "
              value={values.country}
              onChange={handleChange("countryId")}
              // disabled={basicInfo.deleted_at != null ? true : false}
              dir="ltr"
            />
          </Grid>
        </Grid>
      </CardContent>
      <CardActions></CardActions>
    </Card>
  );
};

export default UserAddress;
